const VITE_GESLUB_SERVICE =
  process.env.VITE_GESLUB_SERVICE || "http://192.168.1.11:4001";

export const API = {
  GESLUB: VITE_GESLUB_SERVICE,
};

export const APP_PLATFORM_ID = "9421aa28-12d9-42b4-a766-01e27f97f6ba";

// TODO: Add Sentry DSN Stocks in env variables for CI/CD Github Actions
export const SENTRY = {
  DSN:
    import.meta.env.VITE_SENTRY_DSN ||
    "https://7f26deb80b1f5d20d0c6aa6fabdcf9da@o4505562407632896.ingest.us.sentry.io/4508779897552896",
};

export const REPORTEPP =
  "https://lookerstudio.google.com/embed/reporting/3d89da0d-a4fe-4b73-9dcf-71fef967c067/page/TQjWE";
export const REPORTGENERAL =
  "https://lookerstudio.google.com/embed/reporting/80486b3c-41e3-45ff-bc08-c07f0632660d/page/rDSWE";
